import React from "react";
import PropTypes from "prop-types";
import {t} from "i18next";

const Source = ({source, source_uri}) => {
  if (source && source_uri) {
    return (
      <span>
        {t("incidentDetail.detail.reportedBy")}
        <a
          href={source_uri}
          target="_blank"
          rel="noopener noreferrer"
          data-testid={"Source-Link"}>
          <strong>{source}</strong>
        </a>
      </span>
    );
  }
  if (source) {
    return (
      <span data-testid={"Source-Span-no-uri"}>
        {t("incidentDetail.detail.reportedBy")}
        <strong>{source}</strong>
      </span>
    );
  }
  return null;
};

Source.propTypes = {
  source: PropTypes.string,
  source_uri: PropTypes.string
};

export default Source;
